import React from 'react';
import styled from 'styled-components';
import { Flex, FlexColumn, CardContainer } from '../../Reusable/Container'
import { Text, Tag } from '../../Reusable/Text'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 40px 0;
  gap: 4px;
`;

const Item = styled.div`
  height: 16px;
  border-left: 1px solid #4F4F7B;
  border-right: 1px solid #4F4F7B;
  border-bottom: 1px solid #4F4F7B;
`;

const HorizontalLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 16px;
  border-left: 1px solid #4F4F7B;
  border-right: 1px solid #4F4F7B;
  border-bottom: 1px solid #4F4F7B;
`;

const VerticalTick = styled.div`
  position: absolute;
  top: 10;
  left: 50%;
  width: 1px;
  height: 8px;
  background-color: #3C3C64; // same as line
  transform: translateX(-50%);
`;


export const PaymentLinkPageLabel = () => {
  return (
    <Flex fullWidth between gap="4px" style={{ padding: '0 16px' }}>
      <FlexColumn centerH fullWidth>
        <Item style={{ width: '100%' }}>
          {/* <HorizontalLine style={{ width: '100%' }} /> */}
          {/* <VerticalTick /> */}
        </Item>
        <div style={{ width: 1, height: 14, background: '#4F4F7B' }} />
        <Text size="14px" center width="320px" color="#8181A0" margin="2px 0 0 0">
          Customize your billing link page to your company’s branding and invoicing guidelines
        </Text>

      </FlexColumn>
      <FlexColumn centerH style={{ width: 320, minWidth: 320 }}>
        <Item style={{ width: 320, minWidth: 320 }}>
          {/* <HorizontalLine style={{ width: 290 }} /> */}
          {/* <VerticalTick /> */}
        </Item>
        <div style={{ width: 1, height: 14, background: '#4F4F7B' }} />
        <Text size="14px" center color="#8181A0" margin="2px 0 0 0">
          Your customers will be able to select from payment options and verify their bank details
        </Text>
      </FlexColumn>
    </Flex>
  );
};
